<template>
  <a v-if="toShow" class="image-tile" :class="{ 'not-link': !url }" :href="formattedUrl" @click="onImageTileClicked($event)">
    <div class="desktop">
      <PreserveRatio :width="desktopImage && desktopImage.width" :height="desktopImage && desktopImage.height">
        <responsive-image :url="desktopImage.url" />
      </PreserveRatio>
    </div>
    <div class="mobile">
      <PreserveRatio :width="mobileImage && mobileImage.width" :height="mobileImage && mobileImage.height">
        <responsive-image :url="mobileImage.url" :widths="[320, 425, 768, 970]" :breakpoints="[320, 425, 768, 970]" />
      </PreserveRatio>
    </div>
  </a>
</template>

<script>
import ResponsiveImage from '@/components/commons/ResponsiveImage.vue';
import PreserveRatio from '@/components/commons/PreserveRatio.vue';

export default {
  name: 'ImageTile',
  components: {
    ResponsiveImage,
    PreserveRatio,
  },
  props: {
    actionType: String,
    desktopImage: Object,
    mobileImage: Object,
    type: String,
    url: String,
  },
  data() {
    return {
      formattedUrl: this.url,
      toShow: true,
      mounted: false,
    };
  },
  serverPrefetch() {
    this.formatLandingUrl();
  },
  beforeMount() {
    this.formatLandingUrl();
  },
  mounted() {
    this.mounted = true;
  },
  methods: {
    onImageTileClicked(event) {
      if (!this.url || this.actionType.includes('POPUP')) {
        event.preventDefault();
      }
    },

    formatLandingUrl() {
      const { name } = this.$router.resolve({
        path: this.url,
      });
      if (name === 'landing') {
        this.formattedUrl += `${this.formattedUrl.split('?')[1] ? '&' : '?'}s=true`;
      }
    },
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.image-tile {
  &.not-link {
    cursor: initial;
  }

  @media (min-width: $mobile-breakpoint) {
    .mobile {
      display: none;
    }
  }

  @media (max-width: calc($mobile-breakpoint - 1px)) {
    .desktop {
      display: none;
    }
  }
}
</style>
